<template>
  <div class="app position-relative" v-bind:class="{'position-fixed': isOverlayVisibleValue}" v-on="{mouseover:handler}">
    <div class="container-fluid h-100">
      <div class="row h=100" v-if="$store.state.isUserProfileLoaded === false && ($route.query.key === '' || $route.query.key === undefined || $route.query.key === null)">
          <!-- <header-bar-full-width></header-bar-full-width> -->
          <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 float-Right"> -->
           <!-- <div class="row"> -->
             <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 overflow-y-hidden padding-0px">
                <login-ui></login-ui>
            </div>
           <!-- </div> -->
				<!-- </div> -->
      </div>
			<div class="row h-100" v-else>
        <left-menu-bar v-if="isGroupAdmin === false && $route.name.toLowerCase() !== 'dashboard' && ['LearnPerformReport', 'AssessmentReport', 'MeetingMentorReport', 'LeapsAffirmation', 'MSNotif', 'LeapsIntention', 'LeapsEnergy', 'LeapsCategory', 'LeapsAction', 'LeapsMeditation', 'LeapsChallenges', 'courses','users','groups','Challenges','ManageContent','MasterTopic','LearningLevel','Assessment','AssessmentJourney', 'UserResponses','ChallengeReport','UserProgress','Profile','MCQReport','DeepDive','Discussions','cohorts','utilities','email','progressionemail','DashboardEmail','viewsentemails','fileuploader','screenloading','Dashboard','adminactivity','lessonwiseprogress','elementwiseprogress','sendgrid', 'ssoconfiguration','mentora365','m365Report','MomentsReport','missionReport','adaptiveGameReport', 'VATConsumptionReport', 'MilestoneReport', 'CertificateReport'].indexOf($route.name) > -1"></left-menu-bar>
        <header-bar v-if="isGroupAdmin === false && $route.name.toLowerCase() !== 'dashboard' && ['LearnPerformReport', 'AssessmentReport', 'MeetingMentorReport', 'LeapsAffirmation', 'MSNotif', 'LeapsIntention', 'LeapsEnergy', 'LeapsCategory', 'LeapsAction', 'LeapsMeditation', 'LeapsChallenges', 'courses','users','groups','Challenges','ManageContent','MasterTopic','LearningLevel','Assessment','AssessmentJourney', 'UserResponses','ChallengeReport','UserProgress','MCQReport','DeepDive','Discussions','cohorts','utilities','email','progressionemail','DashboardEmail','viewsentemails','fileuploader','screenloading','adminactivity','lessonwiseprogress','elementwiseprogress','sendgrid', 'ssoconfiguration', 'mentora365','m365Report','MomentsReport','missionReport','adaptiveGameReport', 'VATConsumptionReport', 'MilestoneReport', 'CertificateReport'].indexOf($route.name) > -1"></header-bar>
        <div class="float-Right col-xs-10 col-sm-10 col-md-11 col-lg-11" v-if="isGroupAdmin === false && $route.name.toLowerCase() !== 'dashboard' && $route.name.toLowerCase() !== 'newreport'">
           <div class="row">
             <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 overflow-y-hidden">
               <router-view></router-view>
            </div>
           </div>
				</div>
        <div class="float-Right col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="isGroupAdmin === false && ($route.name.toLowerCase() === 'dashboard' || $route.name.toLowerCase() === 'newreport')">
           <div class="row">
             <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 overflow-y-hidden">
               <router-view></router-view>
            </div>
           </div>
				</div>
         <div class="float-Right col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="isGroupAdmin === true && $route.name.toLowerCase() === 'dashboard'">
           <div class="row">
             <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 overflow-y-hidden">
               <router-view></router-view>
            </div>
           </div>
				</div>
        <div class="float-Right col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="isGroupAdmin === true && $route.name.toLowerCase() !== 'dashboard'">
           <div class="row">
             <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 overflow-y-hidden">
               <router-view></router-view>
            </div>
           </div>
				</div>
			</div>
		</div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  </div>
</template>

<script>

import LeftMenuBar from '@/components/LeftNavBar'
import HeaderBar from '@/components/HeaderBar'
import FooterBar from '@/components/FooterBar'
import HeaderBarFullWidth from '@/components/HeaderBarFullwidth'
import Login from '@/pages/Login'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import idleTimeout from 'idle-timeout'
export default {
  mounted: function () {
    this.checkAndSetGlobalIdealTimeout()
  },
  created () {
    this.checkTokenAndLogin()
    this.setDefaultValues()
    window.addEventListener('scroll', this.handleScroll)
    // window.addEventListener('mouseOver', this.handler)
  },
  data: function () {
    return {
      ok: true,
      showAlertDialog: false,
      errorMsg: 'You are not authorized to log in to the admin website.',
      width: window.innerWidth,
      passwordKey: '',
      isGrpAdmin: false,
      timeOut: null,
      userObj: null,
      sessionTimeOutTime: 0
    }
  },
  watch: {
    getUserObjValue: function (newValue, oldValue) {
      this.setDefaultValues()
      this.checkAndSetGlobalIdealTimeout()
    }
  },
  computed: {
    isOverlayVisibleValue: {
      get: function () {
        // alert (this.$store.state.isOverlayVisible)
        return this.$store.state.isOverlayVisible
      }
    },
    isGroupAdmin: {
      get: function () {
        if (parseInt(this.$store.state.curr_user.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        }
        return false
      }
    },
    getUserObjValue: {
      get: function () {
        return this.$store.state.curr_user
      }
    }
  },
  components: {
    'left-menu-bar': LeftMenuBar,
    'header-bar': HeaderBar,
    'header-bar-full-width': HeaderBarFullWidth,
    'login-ui': Login,
    'alert-box': AlertBox,
    'footer-bar': FooterBar
  },
  methods: {
    setDefaultValues: function () {
      var userData = this.$store.state.curr_user
      // console.log('setDefaultValues: ' + JSON.stringify(userData))
      if (userData !== undefined && userData !== 'undefined' && userData !== null && userData !== 'null' && userData !== '') {
        this.userObj = userData
        if (this.userObj.SessionTimeout > 0) {
          this.sessionTimeOutTime = this.userObj.SessionTimeout
        } else {
          this.sessionTimeOutTime = this.userObj.GlobalSessionTimeOutInMinutes !== undefined && this.userObj.GlobalSessionTimeOutInMinutes !== 'undefined' && this.userObj.GlobalSessionTimeOutInMinutes !== null && this.userObj.GlobalSessionTimeOutInMinutes !== 'null' && this.userObj.GlobalSessionTimeOutInMinutes !== '' ? this.userObj.GlobalSessionTimeOutInMinutes : 0
        }
      } else {
        this.userObj = null
      }
    },
    checkAndSetGlobalIdealTimeout: function () {
      // console.log('checkAndSetGlobalIdealTimeout')
      if (this.sessionTimeOutTime > 0) {
        this.timeOut = idleTimeout(() => {
          // console.log('::: ' + new Date() + ' current page name: ' + this.$route.name + ' userObj: ' + this.userObj)
          const currPageName = this.$route.name
          if ((currPageName !== 'login' && currPageName !== 'forgotpassword' && currPageName !== 'resetpassword')) {
            var store = this.$store
            var cookies = this.$cookies
            cookies.remove(constants.LOGIN_COOKIE_KEY)
            cookies.remove(constants.LOGIN_USER_COOKIE)
            store.state.isUserProfileLoaded = false
            localStorage.removeItem(constants.LOGIN_USER_COOKIE)
            localStorage.setItem('selectedMenu', 0)
            localStorage.setItem('selectedSubMenu', 0)
            localStorage.clear()
            this.$store.state.curr_user = null
            this.userObj = null
            this.$store.commit('resetState')
            this.$router.push('/')
          }
        },
          {
            element: document,
            timeout: (1000 * 60 * this.sessionTimeOutTime),
            loop: true
          }
        )
      } else {
        console.log('No ST Found')
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    checkTokenAndLogin () {
      this.passwordKey = this.$route.query.key
      console.log('CHECK KEY ', this.passwordKey)
      if (this.passwordKey === undefined || this.passwordKey === null || this.passwordKey === '') {
        //  Redirect to login
        var cookies = this.$cookies
        var cookieVal = cookies.get(constants.LOGIN_COOKIE_KEY)

        if (cookieVal !== '' && cookieVal !== null) {
          // console.log('LOG COOKIE VALUE IF: ' + cookieVal)
          this.$store.state.access_token = cookieVal
          var userDataCookieVal = cookies.get(constants.LOGIN_USER_COOKIE)
          if (userDataCookieVal !== '' && userDataCookieVal !== null) {
            // console.log('USER DATA COOKIE VAL ' + JSON.stringify(userDataCookieVal))
            this.$store.state.curr_user = userDataCookieVal
            this.$store.state.isUserProfileLoaded = true
          } else {
            this.$store.state.isUserProfileLoaded = false
          }
          //  this.getUserProfile(tokenVal)
        } else {
          // console.log('LOG COOKIE VALUE ELSE: ' + cookieVal)
          this.$store.state.access_token = ''
        }
      } else {
        this.$store.state.passwordRecoveryKey = this.passwordKey
        this.$router.push('/resetpassword?key=' + this.passwordKey)
      }
    },
    handleScroll: function (e) {
      // console.log('Scrolling down - ' + window.scrollY + ' and visible - ' + this.isOverlayVisibleValue)
      // console.log('Mouse pos - ' + window.mouse.x + ' and window width - ' + screen.width)
      if (!this.isOverlayVisibleValue) {
        this.currentScrollYPos = window.scrollY
        if (this.mouseXPos < (screen.width) / 12) {
          // console.log('xPos - ' + this.mouseXPos + ' Inside Left Nav - ' + this.currentScrollYPos)
          window.scrollTo(0, this.currentScrollYPos2)
        } else {
          // console.log('xPos - ' + this.mouseXPos + ' Outside Left Nav - ' + this.currentScrollYPos)
        }
      }
      // else {
      if (this.isOverlayVisibleValue) {
        window.scrollTo(0, this.currentScrollYPos)
      }
    },
    handler: function (e) {
      e = e || window.event
      this.mouseXPos = e.pageX
      if (this.mouseXPos === undefined) {
        this.mouseXPos = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft
      }
      if (this.mouseXPos < (screen.width) / 12) {
        // console.log('xPos - ' + this.mouseXPos + ' Inside Left Nav - ' + this.currentScrollYPos)
        this.currentScrollYPos2 = this.currentScrollYPos
      }
    }
  },
  name: 'app'
}
</script>

<style>

@import 'bootstrap/dist/css/bootstrap.min.css'

.app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.overflow-y-hidden
{
  overflow-y: hidden !important;
}
.position-relative {
  position: relative;
}
.position-fixed {
  position: relative;
  width: 100%;
}
.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.left-color-border
{
	border: 1px solid red;
}
.right-color-border
{
	border: 1px solid green;
}
.leftNavBarBG
{
	background-color: #34495e;
  /*border:1px solid #34495e; */
}
.font-size-14px{
	font-size: 30px;
}
.float-Right
{
	float: right !important;
}
.fullHeight
{
	height:100% !important;
}
.fi-border
{
	border: 1px solid white;
}
 .footer-img
 {
    margin: 0 auto !important;
    display: block;
    position: absolute;
    bottom: 0;
	width: 30%;
 }
 .center-block {
   margin-left:auto;
   margin-right:auto;
   display:block;
}
.text-center {
   text-align:center
}
.margin-Top-14Perc
{
	margin-top: 14%;
}
.margin-Top-5Perc
{
	margin-top: 5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.text-align-left
{
  text-align: left;
}
.margin-Left-4Perc
{
  margin-left: 4%;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
nav>li>a{
  padding-left:5px;
}
.btn:focus{
  outline-width:4px;
}
.padding-0px{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
#d1{
  /* background-color: red !important; */
  height: 300px !important;
}
#d2{
  /* background-color: red !important; */
  height: 322px !important;
}
</style>




// WEBPACK FOOTER //
// src/App.vue